import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IoMdMegaphone } from 'react-icons/io';
import { FiMail, FiUsers, FiFileText, FiMessageCircle } from 'react-icons/fi';
import api from '../../../api/api';
import { IGlobalState } from '../../../model/IGlobalState';
import { CommunicationsCountsResult } from '../../../model/CommunicationsCountsResult';
import Announcements from './Announcements';
import EmailCampaigns from './EmailCampaigns';
import InvestorQuestions from './InvestorQuestions';
import AnnouncementEmailPreview, { AnnouncementView } from './AnnouncementEmailPreview';

// tab bodies are page headers until each screen is pulled from Figma
const placeholder = (title: string): React.FC<{ onChanged?: () => void }> => () => <div className="page-header"><h1>{title}</h1></div>;

// url segment → tab; no segment = Announcements. Social Posts omitted (no source, see outstanding.md).
const tabs = [
    { path: '', label: 'Announcements', icon: <IoMdMegaphone />, count: (c: CommunicationsCountsResult) => c.announcements, component: Announcements },
    { path: 'email-campaigns', label: 'Email Campaigns', icon: <FiMail />, count: (c: CommunicationsCountsResult) => c.emailCampaigns, component: EmailCampaigns },
    { path: 'contacts', label: 'Contacts', icon: <FiUsers />, count: (c: CommunicationsCountsResult) => c.contacts, component: placeholder('Contacts') },
    { path: 'email-templates', label: 'Email Templates', icon: <FiFileText />, count: (c: CommunicationsCountsResult) => c.emailTemplates, component: placeholder('Email Templates') },
    { path: 'investor-questions', label: 'Investor Questions', icon: <FiMessageCircle />, count: (c: CommunicationsCountsResult) => c.investorQuestions, component: InvestorQuestions },
];

const Communications: React.FC = () => {
    const history = useHistory();
    const { tab = '', id, view } = useParams<{ tab?: string; id?: string; view?: string }>();
    const stock = useSelector((state: IGlobalState) => state.currentStock);
    const [counts, setCounts] = useState<CommunicationsCountsResult | null>(null);
    const current = tabs.find(x => x.path === tab) ?? tabs[0];

    const loadCounts = () => { if (stock?.id) api().getCommunicationsCounts(stock.id).then(setCounts).catch(() => setCounts(null)); };

    useEffect(() => {
        setCounts(null);
        loadCounts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stock?.id]);

    return <div className="v2-page communications-v2">
        <div className="sub-tabs">
            {tabs.map(x => <button key={x.path} type="button" className={x === current ? 'active' : ''}
                onClick={() => history.push(`/communications${x.path && `/${x.path}`}`)}>
                {x.icon} {x.label}
                {counts && <span className="badge">{x.count(counts).toLocaleString()}</span>}
            </button>)}
        </div>

        {tab === 'announcement' && id
            ? <AnnouncementEmailPreview sendGuid={id} view={(view || 'details') as AnnouncementView} onChanged={loadCounts} />
            : <current.component onChanged={loadCounts} />}
    </div>;
};

export default Communications;
